<template>
<div class="kt-input-icon" :class="'kt-input-icon--'+align">
    <slot></slot>
    <span class="kt-input-icon__icon" :class="'kt-input-icon__icon--'+align">
        <span>
            <kt-icon ...icon />
        </span>
    </span>
</div>
</template>

<script>
export default {
    props: {
        align: {
            type: String,
            default: 'right',
        },
        icon: {
            type: Object,
            default: function() {
                return {
                    type: 'fa',
                    name: ''
                }
            },
            required: true,
        }
    }
}
</script>

<style>

</style>